// O contato do representante que vai no PDF do cliente -- pedido dela em
// 09/09: antes so existia o e-mail de LOGIN (auth), nunca um comercial de
// verdade nem telefone nenhum. Mora em user_metadata, mesmo lugar de `nome`
// (ver nomeDeExibicao.ts) -- nao existe tabela de perfil separada.

interface UsuarioComContato {
  email?: string | null
  user_metadata?: { nome?: unknown; email_comercial?: unknown; telefone?: unknown } | null
}

export interface ContatoDoRepresentante {
  nome: string
  email: string
  // Opcional no TIPO (a funcao abaixo sempre devolve string, nunca
  // undefined) so pra nao obrigar toda fixture de teste ja existente no
  // projeto -- muitas anteriores a este campo (09/09) -- a ganhar telefone.
  telefone?: string
}

function textoOuVazio(valor: unknown): string {
  return typeof valor === 'string' && valor.trim() !== '' ? valor.trim() : ''
}

export function contatoDoRepresentante(
  usuario: UsuarioComContato | null | undefined,
): ContatoDoRepresentante {
  const metadata = usuario?.user_metadata
  return {
    // Mesmo retrocesso de tres niveis que EnviarPedido.tsx/PreviaEnvio.tsx ja
    // usavam antes deste ciclo (nome -> e-mail de login -> rotulo generico) --
    // centralizado aqui pra nao duplicar a regra nos dois lugares.
    nome: textoOuVazio(metadata?.nome) || textoOuVazio(usuario?.email) || 'Representante',
    // Retrocesso seguro: conta que nunca preencheu email_comercial cai no
    // e-mail de LOGIN, nunca em string vazia -- o PDF sempre teve um e-mail
    // pra mostrar, e isso nao pode regredir.
    email: textoOuVazio(metadata?.email_comercial) || textoOuVazio(usuario?.email),
    telefone: textoOuVazio(metadata?.telefone),
  }
}
